import { render, staticRenderFns } from "./StudyHistory.vue?vue&type=template&id=1daf5a38&"
import script from "./StudyHistory.vue?vue&type=script&lang=js&"
export * from "./StudyHistory.vue?vue&type=script&lang=js&"
import style0 from "./StudyHistory.vue?vue&type=style&index=0&id=1daf5a38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports